import { FC, Fragment, useState, useEffect } from "react";
import React from "react";
import { FormControl, makeStyles, createStyles, Grid } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { InfoBoxRemovalReconstructionApplicationReminder } from "../core/InfoBox";
import moment from "moment";
import { Select, MenuItem } from "../core/Select";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            flexDirection: "row",
            alignItems: "space-evenly",
        },
        p: {
            marginBottom: 0,
        },
    }),
);

export const MONTHS = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
];

export const RemovalReconstructionDateForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.REMOVAL_RECONSTRUCTION_DATE>();

    const fromSecs = values.removalReconstructionDate.value?.from;
    const from = fromSecs ? moment.unix(fromSecs) : moment();
    const [selectedMonth, setSelectedMonth] = useState(fromSecs ? from.month() : -1);
    const [selectedYear, setSelectedYear] = useState(fromSecs ? from.year() : -1);

    const currentYear = moment().year();

    useEffect(() => {
        if (selectedMonth < 0 || selectedYear < 0) return;
        const currentFrom = moment.unix(values.removalReconstructionDate.value?.from || 0);
        if (currentFrom.year() === selectedYear && currentFrom.month() === selectedMonth) return;
        setValues((state) => {
            state.removalReconstructionDate = {
                value: {
                    from: moment
                        .utc({
                            year: selectedYear,
                            month: selectedMonth,
                            date: 1,
                        })
                        .unix(),
                    to: moment
                        .utc({
                            year: selectedYear,
                            month: selectedMonth,
                            date: 1,
                        })
                        .add(1, "month")
                        .unix(),
                },
            };
        });
    }, [selectedMonth, selectedYear, setValues, values]);

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Für wann ist eine Wiederbebauung geplant?
                </h4>
                <p className={[classes.p, formControlStyles.p].join(" ")}>
                    Geben Sie die Wiederbebauung in Monat/Jahr an.
                </p>
                <InfoBoxRemovalReconstructionApplicationReminder />
                <Grid className={formControlStyles.container} container spacing={2}>
                    <Grid item>
                        <FormControl
                            component="fieldset"
                            style={{ display: "flex", flexBasis: "auto" }}
                        >
                            <h4 className={classes.h4} style={{ marginBottom: 0, marginLeft: 24 }}>
                                Monat auswählen *
                            </h4>
                            <Select
                                style={{ width: 320 }}
                                value={selectedMonth < 0 ? -1 : MONTHS[selectedMonth]}
                                onChange={(it) => setSelectedMonth(MONTHS.indexOf(it.target.value))}
                                error={values.removalReconstructionDate.error ? true : false}
                                variant="standard"
                            >
                                {[
                                    selectedMonth < 0 ? (
                                        <MenuItem key={-1} value={-1}>
                                            Monat wählen
                                        </MenuItem>
                                    ) : (
                                        <span key={-1} />
                                    ),
                                    ...MONTHS.map((it) => (
                                        <MenuItem key={it} value={it}>
                                            {it}
                                        </MenuItem>
                                    )),
                                ]}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl
                            component="fieldset"
                            style={{ display: "flex", flexBasis: "auto" }}
                        >
                            <h4 className={classes.h4} style={{ marginBottom: 0, marginLeft: 24 }}>
                                Jahr auswählen *
                            </h4>
                            <Select
                                style={{ width: 320 }}
                                value={selectedYear}
                                onChange={(it) => setSelectedYear(Number.parseInt(it.target.value))}
                                error={values.removalReconstructionDate.error ? true : false}
                                variant="standard"
                            >
                                {[
                                    selectedYear < 0 ? (
                                        <MenuItem key={-2} value={-1}>
                                            Jahr auswählen
                                        </MenuItem>
                                    ) : (
                                        <span key={-1} />
                                    ),
                                    ...[
                                        currentYear,
                                        currentYear + 1,
                                        currentYear + 2,
                                        currentYear + 3,
                                        currentYear + 4,
                                        currentYear + 5,
                                    ].map((it) => (
                                        <MenuItem key={it} value={it}>
                                            {it}
                                        </MenuItem>
                                    )),
                                ]}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    );
};
